import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import { cx } from '@elliemae/ds-utilities/utils';
import DSOverlay from '@elliemae/ds-overlay';
import { Menu } from '@elliemae/ds-menu';
import { PopperPositions } from '@elliemae/ds-popper';
import { components } from 'react-select';
import { Popper } from 'react-popper';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var SelectMenu = /*#__PURE__*/React.memo(function (props) {
  var _props$selectProps = props.selectProps,
      inlineMenu = _props$selectProps.inlineMenu,
      bounds = _props$selectProps.selectMeasure.bounds,
      expandMenuToContainer = _props$selectProps.expandMenuToContainer,
      expandMenuOutsideContainer = _props$selectProps.expandMenuOutsideContainer,
      zIndex = _props$selectProps.zIndex;

  if (inlineMenu) {
    return /*#__PURE__*/React.createElement(components.Menu, props);
  }

  var styleMenu = expandMenuToContainer ? {
    width: bounds.width
  } : {};

  if (expandMenuOutsideContainer) {
    styleMenu.width = 'auto';
  }

  return /*#__PURE__*/React.createElement(DSOverlay, {
    containerProps: {
      className: 'combobox-menu-overlay'
    },
    isOpen: true
  }, /*#__PURE__*/React.createElement(Popper, {
    containerProps: {
      className: 'combobox-menu-overlay-popper'
    },
    modifiers: {
      preventOverflow: {
        enabled: true,
        padding: 0,
        boundariesElement: 'window'
      }
    },
    placement: PopperPositions.BOTTOM_START
  }, function (_ref) {
    var ref = _ref.ref,
        style = _ref.style;
    return /*#__PURE__*/React.createElement("div", {
      ref: ref,
      className: cx('combobox-menu-wrapper-external', expandMenuOutsideContainer && 'combobox-menu-wrapper-external-outside-container'),
      style: _objectSpread(_objectSpread({
        zIndex: zIndex
      }, style), expandMenuOutsideContainer ? {
        width: 'auto'
      } : {})
    }, /*#__PURE__*/React.createElement(Menu, {
      className: cx('combobox-menu-menu', expandMenuOutsideContainer && 'combobox-menu-menu-external-outside-container'),
      style: styleMenu,
      visible: true
    }, /*#__PURE__*/React.createElement(components.Menu, props)));
  }));
});

export default SelectMenu;
//# sourceMappingURL=SelectMenu.js.map
